import React, { Component } from 'react';
import { Icon, Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';

const styles = theme => ({
    layoutRoot: {},
});

class StudentProgress extends Component {

    render() {
        const completedRow = (green, red) => {
            const total = green + red;
            const percent = (green / total) * 100;
            const num = Math.round(percent);
            const zero = Number.isNaN(num);
            return `${zero ? 0 : num}%`;
        }

        const eventGrid = (events) => {
            let blocks = events.map(e => {
                return (
                    <Tooltip title={
                        <React.Fragment>
                            <div>{e.EventName}</div>
                            <div>{e.unscheduled ? 'Self-Paced' : e.EventDate}</div>
                            <div>{e.EventStatus}</div>
                            <div>{Number(e.EventScore).toFixed(1)}</div>
                        </React.Fragment>
                    } 
                        placement="top"
                    >
                    {/* border: `2px solid ${e.EventColor}` */}
                        <div style={{ backgroundColor: e.ProgressBlockColor, height: '25px', width: '25px', margin: '5px', float: 'left',  }}></div>
                    </Tooltip>

                )
            })
            return (
                <div>{blocks}</div>
            )
        }

        const tableRows = this.props.progress.map(row => {
            const colors = {
                green: "#3D9970",
                red: "#FF4136",
                grey: "#AAAAAA"
            };

            const data = row.Events.reduce((pre, cur) => {
                const blockColor = cur.ProgressBlockColor;
                if (blockColor === colors.green) pre.pass++;
                if (blockColor === colors.red) pre.fail++;
                return pre;
            }, { fail: 0, pass: 0 });

            const totalPercent = Math.round((data.pass + data.fail) / row.Events.length);

            return (
                <React.Fragment>
                    <TableRow key={row.student_id}>
                        <TableCell>{row.FullName}</TableCell>
                        <TableCell>{`${totalPercent}%`}</TableCell>
                        <TableCell>{eventGrid(row.Events)}</TableCell>
                        <TableCell>{row.TotalGrade}</TableCell>
                        <TableCell
                            onClick={() => this.props.history.push(`/gradebook/student/event_list/${this.props.company_calendar_course_id}/${row.student_id}`)}
                        >
                            <IconButton>
                                <Icon>arrow_right_alt</Icon>
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </React.Fragment>
            )
        })

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Student Name</TableCell>
                        <TableCell>Complete %</TableCell>
                        <TableCell>Events</TableCell>
                        <TableCell>Course Grade</TableCell>
                        <TableCell>To Gradebook</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableRows}
                </TableBody>
            </Table>
        );
    }

}

export default (StudentProgress);


// WEBPACK FOOTER //
// src/main/content/scheduled_course/StudentProgress.js